import { UserApi, UserDetail, UserRoleEnum as UserRoleEnumGenerated } from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import CurrentUserDetail from '../../model/currentuser/CurrentUserDetail';
import apiConfiguration from '../configuration/apiConfiguration';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import { UserRoleEnum } from '../../model/currentuser/UserRole';

const client = new UserApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const fetchCurrentPouzivatel = async (headers?: object): Promise<ClientResponse<UserDetail>> => {
  const {
    data,
    status,
  } = await client.getCurrentUser(headers);

  return {
    data: map(data),
    responseCode: status,
  };
};

const map = (data: UserDetail): CurrentUserDetail => ({
  uuid: data.uuid,
  login: data.login,
  meno: data.meno,
  organizaciaSkratka: decodeURIComponent(data.organizaciaSkratka),
  organizaciaNazov: data.organizaciaNazov,
  organizaciaUuid: data.organizaciaUuid,
  roles: mapRoleList(data.roleList),
});

const mapRoleList = (roleList: UserRoleEnumGenerated[]): UserRoleEnum[] => (
  !roleList ? [] : roleList.map(opravnenie => UserRoleEnum[opravnenie])
);
